var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-title"},[_c('div',{staticClass:"sub-title-txt ly-cont"},[_c('h2',[_vm._v(_vm._s(this.title))]),_c('p',[_vm._v(_vm._s(this.content))]),_c('p',[_vm._v(_vm._s(this.content2))])])])}
var staticRenderFns = []

export { render, staticRenderFns }